export * from './baProfilePicture.pipe';



// WEBPACK FOOTER //
// /app/src/app/theme/pipes/baProfilePicture/index.ts